// Errores del silo → mensaje para el vendedor. El envelope Fiado (DEC-002) trae `msg` en español
// escrito para humanos en TODOS los DomainError del wizard ("La reserva del equipo expiró (30
// min)", "No hay plan de crédito activo para el nivel GOLD"…). Regla: ante un error tipado se
// muestra ESE msg — los fallbacks genéricos "intenta de nuevo" quedan solo para fallas de red o
// respuestas sin envelope (UNKNOWN_ERROR del parser).
//
// Los códigos que además tienen RECUPERACIÓN (no solo mensaje) se manejan por pantalla:
// p. ej. RESERVATION_EXPIRED (la reserva del equipo dura 30 min y la validan casi todos los
// endpoints 03-09) → volver al paso 3 a re-reservar; DOWN_PAYMENT_OUT_OF_RANGE → clamp + rango.
import { ApiError } from '@/api/errors';

/** Código tipado del error, o null si no es un error del silo. */
export function wizardErrorCode(e: unknown): string | null {
    return e instanceof ApiError ? e.code : null;
}

/** Mensaje del silo si el error es tipado; `fallback` para red caída / errores no-Fiado. */
export function wizardErrorMsg(e: unknown, fallback: string): string {
    if (e instanceof ApiError && e.code !== 'UNKNOWN_ERROR' && e.msg) return e.msg;
    return fallback;
}
